module.exports = __webpack_public_path__ + "static/media/complexPic8.24df699e.png";